

interface Props {
  timeUnit: 'day' | 'week' | 'month';
  onTimeUnitChange: (unit: 'day' | 'week' | 'month') => void;
  bufferEnabled: boolean;
  onBufferToggle: () => void;
  onScrollToToday: () => void;
}

const UNITS: { key: 'day' | 'week' | 'month'; label: string }[] = [
  { key: 'day', label: '일' },
  { key: 'week', label: '주' },
  { key: 'month', label: '월' },
];

export default function WbsHeader({
  timeUnit,
  onTimeUnitChange,
  bufferEnabled,
  onBufferToggle,
  onScrollToToday,
}: Props) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b bg-white">
      <div className="flex items-center gap-2">
        <h1 className="text-xl font-bold text-gray-900">일정</h1>
      </div>

      <div className="flex items-center gap-4">
        {/* 기간 단위 */}
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-500 mr-1">기간:</span>
          {UNITS.map((u) => (
            <button
              key={u.key}
              onClick={() => onTimeUnitChange(u.key)}
              className={`px-2.5 py-1 text-sm rounded font-medium transition-colors ${
                timeUnit === u.key
                  ? 'bg-blue-100 text-blue-700'
                  : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
              }`}
            >
              {u.label}
            </button>
          ))}
        </div>

        {/* 오늘 */}
        <button
          onClick={onScrollToToday}
          className="px-2.5 py-1 text-sm rounded font-medium bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors"
        >
          오늘
        </button>

        {/* 버퍼 토글 */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">버퍼 계산:</span>
          <button
            onClick={onBufferToggle}
            className={`px-3 py-1 text-sm rounded-full font-medium transition-colors ${
              bufferEnabled
                ? 'bg-blue-100 text-blue-700'
                : 'bg-gray-100 text-gray-500'
            }`}
          >
            {bufferEnabled ? 'ON' : 'OFF'}
          </button>
        </div>
      </div>
    </div>
  );
}
